import React, { useContext, useEffect } from 'react';
import { Link } from "react-router-dom";

import {  Row, Col, CardDeck, Button } from "react-bootstrap";

import CardInfo from '../../../components/Card-Info/card-info';
import Loading from "../../../components/Loading"

import BenefitsContext from "../../../context/Benefits/BenefitsContext";

const BenefitAdmin = ({history}) => {

    const benefitsContext = useContext(BenefitsContext);
    const {loading, benefits, benefit, loadBenefits, cacheBenefit, deleteBenefit } = benefitsContext;

    useEffect(() => {        
        const load = () => {
            loadBenefits()
        }
        if(!benefits || benefits.length === 0){ load() }
       // eslint-disable-next-line
    }, []);

    useEffect(() => {
       if(benefit.id){history.push(`/admin/benefit/form`);}
       // eslint-disable-next-line
    }, [benefit]);

    return ( 
        <>
            <Row>
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Beneficios</h1>
                    <hr />
                </Col>
            </Row>

            <Row>
                <Col>
                    <Link to={"/admin/benefit/form"}>
                        <Button 
                            className={"float-right"} 
                            variant="outline-info"> 
                                {"Agregar Nuevo Beneficio"}
                        </Button>   
                    </Link>                
                </Col>
            </Row>

            { loading ? 
                    <Loading /> : null }

            <CardDeck>
                { loading ? null : 
                    benefits.map(  (benefit, index) =>  {
                        return (
                                <CardInfo 
                                    key={benefit.id} 
                                    id={benefit.id}
                                    title={benefit.title} 
                                    resume={benefit.resume} 
                                    expirationDate={benefit.expirationDate} 
                                    benefit={benefit}
                                    setData={cacheBenefit}
                                    isAdmin={true}
                                    deleteFunc={deleteBenefit}
                                />
                            )
                        }
                )}
            </CardDeck>

        </>
     );
     
}
 
export default BenefitAdmin;